import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Plus, Minus } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const FAQSection = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    { qKey: 'faq_1_q', aKey: 'faq_1_a' },
    { qKey: 'faq_2_q', aKey: 'faq_2_a' },
    { qKey: 'faq_3_q', aKey: 'faq_3_a' },
    { qKey: 'faq_4_q', aKey: 'faq_4_a' },
    { qKey: 'faq_5_q', aKey: 'faq_5_a' },
  ];

  return (
    <section 
      id="faq" 
      className="vf-section bg-[#F8FAFC]"
      data-testid="faq-section"
    >
      <div className="vf-container">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="vf-heading-2 text-[#1e3a5f] mb-4">
              {t('faq_title')}
            </h2>
          </motion.div>

          {/* FAQ Items */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={faq.qKey}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="bg-white border-2 border-slate-100 overflow-hidden"
                data-testid={`faq-item-${index + 1}`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-50 transition-colors"
                  data-testid={`faq-button-${index + 1}`}
                >
                  <span className="font-semibold text-[#1e3a5f] pr-4">
                    {t(faq.qKey)}
                  </span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-sm flex items-center justify-center transition-colors ${
                    openIndex === index ? 'bg-[#22c55e]' : 'bg-slate-100'
                  }`}>
                    {openIndex === index ? (
                      <Minus className={`w-5 h-5 ${openIndex === index ? 'text-white' : 'text-[#1e3a5f]'}`} />
                    ) : (
                      <Plus className={`w-5 h-5 ${openIndex === index ? 'text-white' : 'text-[#1e3a5f]'}`} />
                    )}
                  </div>
                </button>
                
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.2 }}
                    >
                      <div className="px-6 pb-5 text-slate-600 border-t border-slate-100 pt-4">
                        {t(faq.aKey)}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
